jQuery(document).ready(function($) {

  PostContinuoOpen()

  var triggerHalf= []
  var triggerFull= []
  var value = $('#main_post').position().top + ($('footer').first().position().top - screen.height - $('#main_post').position().top)/2
  triggerHalf.push(value)

  value = $('footer').first().position().top - screen.height
  triggerFull.push(value)

  var mainID = $('#main_post').attr("main-id");
  var timeOnPage = Date.now();

  $(window).bind('beforeunload', function(){
    time = Math.floor((Date.now() - timeOnPage)/5000)*5
    PostContinuoReadingTime(time);
  });


  var relatedPostsIds = JSON.parse($(".jc-continuous-post").first().text())

  $.ajax({
    url: admin.url,
    type: 'POST',
    data:{
      'action': 'jc_ajax_infinite_scroll_callback',
      'relatedPostsIds': relatedPostsIds,
      'mainID' : mainID,
      'postCount' : 0,
    },
    success: function (response) {
      $(".jc-continuous-post").first().replaceWith(response)
      $("#article-info").removeClass("d-none")
      $("#article-info").slideDown("slow")
    }
  });



  $(window).scroll(function() {

    var pos = $(window).scrollTop();

    var currUrl = $(".jc-post-header").first().attr("url");
    var currTitle = $(".jc-post-header").first().attr("title");

    if ($(".jc-post-header").length > 1 && history.pushState) {
      for (var i=0; i<$(".jc-post-header").length; i++) {
        var trigger = $(".jc-post-header").eq(i).next().position().top;
        if (pos>= trigger) {
          currUrl = $(".jc-post-header").eq(i).attr("url")
          currTitle = $(".jc-post-header").eq(i).attr("title")
          if($(".jc-post-header").eq(i).attr("view") == "false"){
            $(".jc-post-header").eq(i).attr("view", "true")
            RelatedPostPreview(i)
          }
        }
      }
    }

    if (location.href != currUrl) {
      document.title = currTitle
      history.replaceState(null, currTitle, currUrl)
    }

  });

});

function ContagemLeituraPostContinuous() {
  $.ajax({
    url: admin.url_info,
    type: 'GET',
    data: {
      'action': 'jc_ajax_get_category_subcategory'
    },
    success: function (response) {
      if (response && response.success) {
        dataLayer.push({
          'event': 'ga_event',
          'eventCategory': "Categoria",
          'eventAction': "View - " + response.data['category'],
          'eventLabel': response.data['subcategory']
        });

        gtag('event', 'Categoria', {
          'eventAction': "View - " + response.data['category'],
          'eventLabel': response.data['subcategory']
        });
      }
    }
  });
};

function WordpressCountView(currUrl){
  $.ajax({
    url: admin.url,
    type: 'POST',
    data:{
      'action': 'jc_ajax_related_post_view',
      'postUrl': currUrl,
    },
  });
}

function ContinueReadingExpand(post) {
  $('.article-content-'+post).height('auto')
  $('#buttonSeeFullPost-'+post).remove()
  $('.article-content-'+post).css('position','')
  $('.article-content-'+post).css('overflow','visible')

  if ( window["adsPost"+post].length )  window["adsPost"+post].forEach(loadAdsPostLoad)

  var currUrl = $('#related_post_' + post +' .jc-post-header')
  ClickRelatedPostContinueReading(post)
  WordpressCountView(currUrl)
}

function loadAdsPostLoad(item){
  jc_dfp_render_ads(item.selector, item.format, item.screenmap, item.section, item.formatm, item.screenmapm);
}
